import React from 'react'
import styles from './LoadingSkeleton.module.scss'

const LoadingSkeleton = () => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.skeleton}></div>
        <div className={styles.skeleton}></div>
      </div>
      <div className={styles.content}>
        <div className={styles.card}>
          <div className={styles.skeleton}></div>
          <div className={styles.skeleton}></div>
          <div className={styles.skeleton}></div>
        </div>
        <div className={styles.card}>
          <div className={styles.skeleton}></div>
          <div className={styles.skeleton}></div>
          <div className={styles.skeleton}></div>
        </div>
        <div className={styles.card}>
          <div className={styles.skeleton}></div>
          <div className={styles.skeleton}></div>
          <div className={styles.skeleton}></div>
        </div>
      </div>
    </div>
  )
}

export default LoadingSkeleton
